import HomeFeatures from './HomeFeatures'

export default HomeFeatures